<template>
  <div class="preview-modal">
    <div class="preview-content">
      <div class="preview-header">Email Preview</div>
      <div class="label-row">
        <span class="label">From:</span>
        <span>{{ from }}</span>
      </div>
      <div class="label-row">
        <span class="label">To:</span>
        <span>{{ to }}</span>
      </div>
      <div class="label-row">
        <span class="label">Subject:</span>
        <span>{{ subject }}</span>
      </div>

      <!-- Display attachment information if available -->
      <div class="label-row" v-if="attachmentName">
        <span class="label">Attachment:</span>
        <span> <i class="fas fa-paperclip"></i> {{ attachmentName }} </span>
      </div>

      <div v-html="body" class="email-body"></div>
      <div class="button-row">
        <button @click="$emit('sendAll')">Send It</button>
        <button @click="$emit('closePreview')">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['from', 'to', 'subject', 'body', 'attachmentName'],
};
</script>

<style scoped>
.preview-header {
  background: #333;
  padding: 8px;
  color: #eee;
  margin: -20px;
  margin-bottom: 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.preview-modal {
  position: fixed;
  width: 500px;
  height: 515px;
  overflow-y: auto;
  font-size: 0.8em;
  z-index: 999999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 5px;
  border: 1pt solid #ccc;
  box-shadow: 6px 7px 10px 6px rgba(0, 0, 0, 0.1);
}

.email-body {
  margin-top: 20px;
  border-top: 1px solid #ddd;
  padding: 5px;
  border: 1pt solid #ddd;
  min-height: 345px;
  max-height: 345px;
  border-radius: 5px;
  overflow-y: auto;
}

.button-row {
  position: fixed;
  bottom: 14px;
  right: 19px;
  margin-top: 5px;
}

.button-row button {
  margin-left: 4px;
}

.label-row {
  display: flex;
  margin-bottom: 10px;
}

.label {
  width: 80px; /* Adjust this width to your preference */
  font-weight: bold;
  margin-right: 10px;
}

/* Optional styling for the attachment icon */
.fa-paperclip {
  margin-right: 5px;
  color: #333;
}
</style>
